import { FieldErrors } from 'react-hook-form';

export const getFieldErrorObject = (errors: FieldErrors = {}, name: string): any => {
  if (
    !Object.keys(errors).length || // If there are no errors, return an empty object
    !name.includes('.') // If the name doesn't include a dot, it's a top-level field
  )
    return errors?.[name];

  // Otherwise, we need to traverse the object to find the array of errors
  const keys = [...name.split('.')];
  let current = errors;
  while (keys.length > 0) {
    const currentKey = keys[0];
    current = current[currentKey] as any;
    if (current instanceof Array) return current;
    keys.shift();
  }

  return {};
};
